import { render, staticRenderFns } from "./TagManager.vue?vue&type=template&id=226f4592&scoped=true"
import script from "./TagManager.vue?vue&type=script&lang=js"
export * from "./TagManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f4592",
  null
  
)

export default component.exports